import { Box, Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';

export const ListsPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container maxWidth="md" style={{ paddingTop: 16, paddingBottom: 16 }}>
      <Box pt={1} pb={2} display="flex" className="spacing">
        <Skeleton variant="circular" width={40} height={40} />
        <Box display={"flex"} flexDirection="column">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={50} height={20} />
        </Box>
      </Box>

      <Grid container spacing={3} justifyContent={isMobile ? "center" : "flex-start"}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Grid key={`IF_SKE_${i}`} item>
            <Skeleton variant="rectangular" style={{ borderRadius: 4 }} width={200} height={200} />
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={50} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ListsPageSkeleton;
